export var NPSStatus;
(function (NPSStatus) {
    NPSStatus[NPSStatus["OPEN"] = 1] = "OPEN";
    NPSStatus[NPSStatus["FINISH"] = 2] = "FINISH";
})(NPSStatus || (NPSStatus = {}));
